module.exports = __webpack_public_path__ + "img/tarj-afiliarse.b10ae498.jpg";